/**
 * @generated SignedSource<<28b371abef204067e25c78c1125166cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SocialLoginGetSocialLoginRedirectUrlMutation$variables = Record<PropertyKey, never>;
export type SocialLoginGetSocialLoginRedirectUrlMutation$data = {
  readonly getSocialLoginRedirectUrl: {
    readonly data: string | null;
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type SocialLoginGetSocialLoginRedirectUrlMutation = {
  response: SocialLoginGetSocialLoginRedirectUrlMutation$data;
  variables: SocialLoginGetSocialLoginRedirectUrlMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GetSocialLoginRedirectUrlResponse",
    "kind": "LinkedField",
    "name": "getSocialLoginRedirectUrl",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SocialLoginGetSocialLoginRedirectUrlMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SocialLoginGetSocialLoginRedirectUrlMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "d00358777f93b0aa0440f6d94dbbb40e",
    "id": null,
    "metadata": {},
    "name": "SocialLoginGetSocialLoginRedirectUrlMutation",
    "operationKind": "mutation",
    "text": "mutation SocialLoginGetSocialLoginRedirectUrlMutation {\n  getSocialLoginRedirectUrl {\n    data\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5b26f1adc8a75b21f35dc4ca4d863ee3";

export default node;
